import React, { useState, useEffect } from "react";

const CountdownTimer = ({
  message,
  durationInSeconds,
  onComplete,
  format = "seconds",
  className,
}) => {
  const [timeLeft, setTimeLeft] = useState(durationInSeconds);

  useEffect(() => {
    if (timeLeft <= 0) {
      onComplete();
      return;
    }

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [timeLeft, onComplete]);

  const formatTime = (seconds, formatType) => {
    if (formatType === "minutes") {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${message} ${minutes}:${
        remainingSeconds < 10 ? "0" : ""
      }${remainingSeconds}`;
    }
    return `${message} ${seconds}s`;
  };

  return <span className={className}>{formatTime(timeLeft, format)}</span>;
};

export default CountdownTimer;
